import LoaiToKhai from "./LoaiToKhai";

export default LoaiToKhai